import { theme } from '@acorns/grove'
import styled from 'styled-components'

export const Text = styled.span`
  font-size: 12px;
  color: ${theme.colors.primaryStone};
  text-align: center;
  display: block;
  width: 100%;
`
